import { useCallback } from "react";
import FocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import copyText from "@/core/helpers/copyText";
import { Icon, SoundButton, ValidateCode } from "@/shared/ui";

type Props = {
  onSubmit: () => void;
  code: string;
  onCodeChange: (value: string) => void;
  error?: string;
  pending?: boolean;
  qr: string;
  backupCode: string;
};

export default function PlayerMenuSettingsSafetyEnableTfaAuthenticatorCheckContainer({
  onSubmit,
  code,
  onCodeChange,
  error = "",
  pending = false,
  qr,
  backupCode,
}: Props) {
  const copyBackupCode = useCallback(() => {
    copyText(backupCode);
  }, [backupCode]);

  return (
    <FocusLock className="grow flex flex-col w-full h-full">
      <div className="flex items-center p-2.5 bg-white/10 rounded-[0.75rem] gap-5">
        <div className="shrink-0 bg-gradient-red w-[7.5rem] h-[7.5rem] rounded-[0.75rem] flex items-center justify-center">
          <Icon name="google-auth" className="w-[2.625rem] bg-white" />
        </div>
        <div className="grow text-12 text-white font-bold uppercase text-left">
          Установите Google Authenticator или любой аналогичный Authenticator на свой смартфон
        </div>
      </div>
      <div className="flex items-center p-2.5 bg-white/10 rounded-[0.5rem] mt-2 gap-5">
        <div className="shrink-0 bg-white w-[7.5rem] h-[7.5rem] rounded-[0.75rem] flex items-center justify-center">
          {qr ? (
            <img src={`data:image/webp;base64,${qr}`} alt="" className="rounded-[0.75rem]" />
          ) : (
            <div className="mz-loader w-5 h-5 text-white" />
          )}
        </div>
        <div className="grow flex flex-col items-start">
          <div className="text-12 text-white font-bold uppercase text-left">
            Откройте ваше приложение Authenticator, отсканируйте код с помощью камеры своего
            смартфона
          </div>
          <div className="flex flex-col items-start mt-2.5">
            <div className="text-15 text-white/50 font-medium">
              Код для ручного ввода в Authenticator:
            </div>
            <div className="mt-1 flex items-center gap-2">
              <div className="text-accent text-16 font-bold">{backupCode}</div>
              <SoundButton variant="surface" className="p-0 h-7 w-7" onClick={copyBackupCode}>
                <Icon name="copy" className="w-4 bg-accent-solid" />
              </SoundButton>
            </div>
          </div>
        </div>
      </div>
      <ValidateCode
        onSubmit={onSubmit}
        type={TfaMethod.AUTHENTICATOR}
        address=""
        description="Введите 6-значный код из вашего приложения"
        onSendCode={() => {}}
        code={code}
        onCodeChange={onCodeChange}
        pending={pending}
        sendCodePending={false}
        error={error}
        className="mt-2.5"
      />
    </FocusLock>
  );
}
